import React, { Component } from 'react'
import { Card } from 'reactstrap';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import './style.css';

import Config from '../../config';

class Documentation extends Component {
 constructor(props) {
  super(props)
  this.state = { }
  this.api = require('../../../openapi.'+this.props.session.language+'.json')
  this.api.servers = [{url: Config.apiURI + '/api'}];
 }

 render() {
  return (
   <Card>
    <SwaggerUI spec={this.api} />
   </Card>
  )
 }
}


export default Documentation


// WEBPACK FOOTER //
// ./websources/components/Documentation/index.js